import {createAsyncThunk, createSlice, PayloadAction,UnknownAction} from "@reduxjs/toolkit";
import axios from 'axios';

import {RootState} from './rootReducer'
import {persistReducer} from "redux-persist";
import storageSession from 'redux-persist/lib/storage/session';
import {closeBackdrop, openBackdrop} from "./backdrop";
import {openNotifier} from "./notifier";
import dayjs from "dayjs";
// @ts-ignore
import {saveAs} from "file-saver";
import {IVehicle} from "./vehicles";
const apiUrl = process.env.REACT_APP_API_URL;

export interface IReport {
    fchOperacion:any,
    dateOperation:any,
    idGuia?: number[],
    incidencia?:string,
    comentario?:string,
    idvehiculostipo?:number,
    idVehiculo_operacion?:number,
    idHorario: number,
    idEmpresa?:number,
    idTipo_vehiculo: number,
    intAdulto?:number,
    intMenor?: number,
    vehiculos: IVehiculoGuia[],
    strDes_operacion: string,
    strIncidencia:string
    idTour_operacion?:number

}
export interface IVehiculoGuia{
    idVehiculo: number[],
    idGuia: number,
    idTipo_vehiculo:number
}

interface IReportState {
    report:IReport,
    reports:IReport[]
    loading:boolean,
    meta: {
        current_page: number,
        per_page:string,
        total: number
    },
    loadingEdit:boolean,
    report_generate:{
        isGenerate:boolean
    }


}
export interface IVehiculoPost{
    idVehiculo: number,
    idGuia: number,
    isResponsable:number
}
export interface IReportPost{
    fchOperacion:any,
    idHorario:number,
    strDes_operacion: string,
    strIncidencia:string,
    vehiculos:{
        intAdulto:number | undefined,
        intMenor:number | undefined,
        idTipo_vehiculo:number,
        details:[
            {
                idVehiculo: number,
            idGuia: number,
            isResponsable: boolean,
            }
        ]
        }[],
}

export interface IReportConvert{
    isFirst: boolean,
    fchOperacion?: any,
    idHorario: number,
    intAdulto?:number,
    intMenor?:number,
    idTiposVehiculo?:number,
    vehicles: {     idVehiculo: number;     idGuia: number;     idTiposVehiculo: number;     intAdulto?: number;     intMenor?: number;     isResponsable: boolean; }[],
    strDes_operacion: string,
    strIncidencia:string,
}
export const initialState: IReportState = {
    report:{
        fchOperacion: '',
        idVehiculo_operacion:0,
        dateOperation: dayjs().format('YYYY-MM-DD'),
        idGuia: [],
        idHorario: 0,
        idTipo_vehiculo: 0,
        intAdulto: 0,
        intMenor: 0,
        idEmpresa:0,
        vehiculos: [],
        strDes_operacion: "",
        strIncidencia: ""
    },
    reports:[],
    meta: {
        current_page: 1,
        per_page: '10',
        total: 0
    },
    loadingEdit:false,
    report_generate:{
        isGenerate:false
    },
    loading:false
};
export const addReport = createAsyncThunk<string,
    { report: IReportPost},
    {
        rejectValue: unknown
    }>(
    'cart/addReport',
    async (data, thunkApi) => {
        thunkApi.dispatch(openBackdrop())

        try {
            const response = await axios.post(`${apiUrl}/operation`, data.report);

            thunkApi.dispatch(openNotifier({open:true,variant:"success",message:response?.data}))
            thunkApi.dispatch(resetReport());
            //list vehicles
            thunkApi.dispatch(listReport({page: 1, items: 10}))
           thunkApi.dispatch(closeBackdrop());
            return  response.data;
        } catch (err) {

            thunkApi.dispatch(closeBackdrop());

            // @ts-ignore
            // thunkApi.dispatch(openNotifier({open:true,variant:"error",message:err?.response?.data?.message??'Ha ocurrido un error y el sistema se ha tenido que cerrar'}))
            // @ts-ignore
            return thunkApi.rejectWithValue(err.response.data)
        }
    }
)
export const getReport = createAsyncThunk<IReport,
    { id: string},
    {
        rejectValue: unknown
    }>(
    'cart/getReport',
    async ({id}, thunkApi) => {
        thunkApi.dispatch(openBackdrop())
        try {
            const response = await axios.get(`${apiUrl}/operation/show/${id}`);
            thunkApi.dispatch(openNotifier({open:true,variant:"success",message:``}))
            //list vehicles
            //thunkApi.dispatch(listVehicles({}))
            thunkApi.dispatch(closeBackdrop());
            return  response.data;
        } catch (err) {
            thunkApi.dispatch(closeBackdrop());

            // @ts-ignore
            // thunkApi.dispatch(openNotifier({open:true,variant:"error",message:err?.response?.data?.message??'Ha ocurrido un error y el sistema se ha tenido que cerrar'}))
            // @ts-ignore
            return thunkApi.rejectWithValue(err.response.data)
        }
    }
)
export const listReport = createAsyncThunk<
    {
        data:IReport[],
        current_page: number,
        per_page: string,
        total: number
    },
    { page: number, items: number},
    {
        rejectValue: unknown
    }>(
    'cart/listReport',
    async ({page,items}, thunkApi) => {
        thunkApi.dispatch(openBackdrop())
        try {
            const response = await axios.get(`${apiUrl}/operation?page=${page}&items=${items}`);
            thunkApi.dispatch(openNotifier({open:true,variant:"success",message:``}))
            //list vehicles
            //thunkApi.dispatch(listVehicles({}))
            thunkApi.dispatch(closeBackdrop());
            return  response.data;
        } catch (err) {
            thunkApi.dispatch(closeBackdrop());

            // @ts-ignore
            // thunkApi.dispatch(openNotifier({open:true,variant:"error",message:err?.response?.data?.message??'Ha ocurrido un error y el sistema se ha tenido que cerrar'}))
            // @ts-ignore
            return thunkApi.rejectWithValue(err.response.data)
        }
    }
)


export const updateReport = createAsyncThunk<string,
    { id: number,report:IReportPost,currentPage:number},
    {
        rejectValue: unknown
    }>(
    'cart/updateReport',
    async ({id,report,currentPage}, thunkApi) => {
        thunkApi.dispatch(openBackdrop())
        try {
            const response = await axios.put(`${apiUrl}/operation/update/${id}`,report);

            thunkApi.dispatch(openNotifier({open:true,variant:"success",message:`${response?.data}`}))
            thunkApi.dispatch(resetReport());
            //list vehicles
            thunkApi.dispatch(listReport({page: currentPage, items: 10}))

            thunkApi.dispatch(closeBackdrop());
            return  response.data;
        } catch (err) {
            thunkApi.dispatch(closeBackdrop());

            // @ts-ignore
            // thunkApi.dispatch(openNotifier({open:true,variant:"error",message:err?.response?.data?.message??'Ha ocurrido un error y el sistema se ha tenido que cerrar'}))
            // @ts-ignore
            return thunkApi.rejectWithValue(err.response.data)
        }
    }
)
export const disabledReport = createAsyncThunk<string,
    { id: number,currentPage:number},
    {
        rejectValue: unknown
    }>(
    'cart/disabledReport',
    async ({id,currentPage}, thunkApi) => {
        thunkApi.dispatch(openBackdrop())
        try {
            const response = await axios.delete(`${apiUrl}/operation/changeStatus/${id}`);
            thunkApi.dispatch(openNotifier({open:true,variant:"success",message:``}))
            thunkApi.dispatch(resetReport());
            //list vehicles
            thunkApi.dispatch(listReport({page: currentPage, items: 10}))

            thunkApi.dispatch(closeBackdrop());
            return  response.data;
        } catch (err) {
            thunkApi.dispatch(closeBackdrop());

            // @ts-ignore
            // thunkApi.dispatch(openNotifier({open:true,variant:"error",message:err?.response?.data?.message??'Ha ocurrido un error y el sistema se ha tenido que cerrar'}))
            // @ts-ignore
            return thunkApi.rejectWithValue(err.response.data)
        }
    }
)
export const  generateReport = createAsyncThunk<string,
    { dateStart: any,dateEnd:any},
    {
        rejectValue: unknown
    }>(
    'cart/generateReport',
    async ({dateStart,dateEnd}, thunkApi) => {
        thunkApi.dispatch(openBackdrop())
        try {
            const response = await axios.get(`${apiUrl}/report/operation?start_date=${dateStart}&end_date=${dateEnd}`,{responseType: "arraybuffer"});


            let dayStart=dayjs(dateStart).format("DD-MM-YYYY")
            let dayEnd=dayjs(dateEnd).format("DD-MM-YYYY")
            //list vehicles
            const dayGet=dayStart===dateEnd?`${dayStart}`:`${dayStart}_al_${dayEnd}`
            const outputFilename = `reporte_operaciones_del_${dayGet}.xlsx`;
            const blob = new Blob([response?.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, outputFilename);
            thunkApi.dispatch(openNotifier({open:true,variant:"success",message:`Reporte Generado con éxito`}))
            thunkApi.dispatch(resetReportGenerate());
            thunkApi.dispatch(closeBackdrop());
            return  response.data;
        } catch (err) {
            thunkApi.dispatch(closeBackdrop());

            // @ts-ignore
            thunkApi.dispatch(openNotifier({open:true,variant:"error",message:err?.response?.data?.message??'Ha ocurrido un error al generar el reporte'}))
            // @ts-ignore
            return thunkApi.rejectWithValue(err.response.data)
        }
    }
)



const reportSlice = createSlice({
    name: 'report',
    initialState,
    extraReducers: builder => {
        builder
            .addCase(addReport.pending, state => {
                state.loading = true
            })
            .addCase(addReport.fulfilled, (state, {payload}) => {
                state.loading = false
            })
            .addCase(addReport.rejected, (state, action) => {
                state.loading = false
            })
            .addCase(getReport.pending, state => {
                state.loading = true
            })
            .addCase(getReport.fulfilled, (state, {payload}) => {
                state.loading = false
                state.report=payload
            })
            .addCase(getReport.rejected, (state, action) => {
                state.loading = false
            })
            .addCase(updateReport.pending, state => {
                state.loading = true
            })
            .addCase(updateReport.fulfilled, (state, {payload}) => {
                state.loading = false
            })
            .addCase(updateReport.rejected, (state, action) => {
                state.loading = false
            })
            .addCase(generateReport.pending, state => {
                state.loading = true
            })
            .addCase(generateReport.fulfilled, (state, {payload}) => {
                state.loading = false
                state.report_generate.isGenerate=true
            })
            .addCase(generateReport.rejected, (state, action) => {
                state.loading = false
            })
            .addCase(disabledReport.pending, state => {
                state.loading = true
            })
            .addCase(disabledReport.fulfilled, (state, {payload}) => {
                state.loading = false

            })
            .addCase(disabledReport.rejected, (state, action) => {
                state.loading = false
            })
            .addCase(listReport.pending, state => {
                state.loading = true
            })
            .addCase(listReport.fulfilled, (state, {payload}) => {

                const {data} = payload
                state.loading = false
                state.meta.total=payload.total
                state.meta.current_page=payload.current_page
                state.meta.per_page=payload.per_page
                state.reports=data

            })
            .addCase(listReport.rejected, (state, action) => {
                state.loading = false
            })

    },
    reducers: {
        resetReport:(state)=>{
            state.report=initialState.report
        },
        resetReportGenerate:(state)=>{
            state.report_generate=initialState.report_generate
        },
        startEditLoading:(state)=>{
            state.loadingEdit=true
        },
        finishEditLoading:(state)=>{
            state.loadingEdit=false
        },
    },
});

export const {resetReport,resetReportGenerate,startEditLoading,finishEditLoading} = reportSlice.actions

export const ReportSelector = (state: RootState) => state.report

export const ReportMetaSelector = (state: RootState) => {
    return {
        meta: state.report.meta,
        data: state.report.data,
        loadingVehiclesPaginate: state.report.loading,
    };
};







export const ReportReducer = persistReducer({
    storage: storageSession,
    key: 'report',
    whitelist: [''],
    blacklist:['']
}, reportSlice.reducer)
